/* card-price-fix.js (Price LEFT, SoldOut RIGHT, deduped, force layout)
 * - 集合/目录页卡片：左边“价格”，右边“售罄”
 * - 自动隐藏按钮原生“售罄”文字（按钮会加 .has-injected-price）
 * - 防并发/防重复插入；强制 flex 布局覆盖全局 inline-flex!important
 */
(function () {
  var moneyFormat = (typeof window.__moneyFormat === 'string' && window.__moneyFormat) || '${{amount}}';
  var soldOutText = (typeof window.__tSoldOut === 'string' && window.__tSoldOut) || 'Sold out';

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    cents = Math.round(Number(cents));
    var noDecimals = (cents / 100).toFixed(0);
    var amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\$\{\{amount\}\}/g, '$' + amount);
  }

  function getHandleFromHref(href) {
    try {
      var url = new URL(href, location.origin);
      var parts = url.pathname.split('/').filter(Boolean);
      var i = parts.indexOf('products');
      return i > -1 && parts[i + 1] ? parts[i + 1] : null;
    } catch (e) { return null; }
  }

  // 左侧价格（含对比价），右侧售罄 —— 强制 flex 布局
  function buildRowHTML(priceCents, compareAtCents) {
    var price = formatMoney(priceCents);
    var compare = (compareAtCents && compareAtCents > priceCents) ? formatMoney(compareAtCents) : '';
    var compareHTML = compare
      ? '<span class="product-prices-compare-at-price" style="margin-right:.5rem;">' + compare + '</span>'
      : '';

    var style = 'display:flex!important;justify-content:space-between;align-items:center;width:100%';

    return (
      '<p class="product-prices product-card__prices liquid price-row" style="' + style + '">' +
        // 左：价格
        '<span class="price-left text-body-s-regular">' +
          compareHTML +
          '<span class="product-prices__price text-body-s-regular">' + price + '</span>' +
        '</span>' +
        // 右：售罄
        '<span class="product-prices__sold-out text-body-s-regular soldout-right">' + soldOutText + '</span>' +
      '</p>'
    );
  }

  async function injectForCard(card) {
    var button = card.querySelector('.product-card__add-button.is-disabled');
    if (!button) return;

    // 防并发/防重复
    if (button.dataset.priceInjecting === '1' || button.dataset.priceInjected === '1') return;
    if (button.querySelector('.product-prices, .product-card__prices, .product-prices__price')) {
      button.dataset.priceInjected = '1';
      button.classList.add('has-injected-price'); // 用于隐藏原生“售罄”文本
      return;
    }
    button.dataset.priceInjecting = '1';

    try {
      var label = button.querySelector('.product-card__button-label') || button;

      // 取 handle
      var anchor = card.closest('a.product-card') || card.querySelector("a[href*='/products/']");
      if (!anchor) throw new Error('no anchor');
      var handle = getHandleFromHref(anchor.getAttribute('href'));
      if (!handle) throw new Error('no handle');

      // 拉取产品 JSON
      var res = await fetch('/products/' + handle + '.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('fetch fail');
      var data = await res.json();
      var variant = (data.variants || [])[0];
      if (!variant) throw new Error('no variant');

      // 清旧价块 → 插入新排版（左价右售罄）
      label.querySelectorAll('.product-card__price').forEach(function (n) { n.remove(); });
      var html = buildRowHTML(variant.price, variant.compare_at_price);
      var wrap = document.createElement('div');
      wrap.className = 'product-card__price';
      wrap.innerHTML = html;
      label.appendChild(wrap);

      button.classList.add('has-injected-price'); // 隐藏按钮原生“售罄”
      button.dataset.priceInjected = '1';
    } catch (e) {
      delete button.dataset.priceInjecting; // 失败允许重试
    }
  }

  function run() {
    document.querySelectorAll('.product-card__add-button.is-disabled').forEach(function (btn) {
      var card = btn.closest('.product-card');
      if (card) injectForCard(card);
    });
  }

  // 初次 + 观察 DOM 变化
  var tries = 0;
  var interval = setInterval(function(){ run(); if (++tries > 20) clearInterval(interval); }, 300);

  var mo = new MutationObserver(function(muts){
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) { run(); break; }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
